export default __webpack_public_path__ + "static/media/deep_roots_large.82cbdc88.jpg";